// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mobile-specific styles */
@media screen and (max-width: 991px) {
    .account__left {
        width: 100%;
        /* Image takes full width on mobile */
        height: 50%;
        /* Takes 50% of the height */
    }

    .account__right {
        width: 100%;
        /* Form takes full width on mobile */
        height: 50%;
        /* Takes 50% of the height */
        padding: 0px 20px;
        /* Optional: adds padding for the form on mobile */
        padding-top: 20px;
    }

    .account__right_box {
        min-height: 0px;
    }

    .most_follwed {
        height: 200px;
        margin: 0 auto;
        position: absolute;
        top: 40px;
        z-index: 0;
        border-radius: 10px;
    }

    .section-heading__1 {
        font-size: 24px;
    }

    .intractive {
        font-size: 21px;
        width: 100%;
    }

    .section-title {
        font-size: 1.5rem;
    }

    .card-img {
        width: 45%;
        height: 140px;
        border-radius: 10px;
        object-fit: cover;
    }

    .spl_burron img {
        width: 70%;
    }

    .feed_details_img {
        width: 100%;
        height: auto;
        margin: 20px auto;
    }

    .upload_popup_medai2 .modal-body .uplad_img:first-of-type {
        width: 90%;
        height: 250px;
    }

    .upload_popup_medai2 .modal-body .uplad_img:not(:first-of-type) {
        width: 90%;
        height: 250px;
    }

    .upload_popup_medai3 .modal-body .uplad_img:first-of-type {
        width: 90%;
        height: 250px;
    }

    .upload_popup_medai3 .modal-body .uplad_img:not(:first-of-type) {
        width: 90%;
        height: 250px;
    }

}


@media (max-width: 767px) {
    /* .desktop-svg {
        display: none;
    }
*/

    .mobile-svg {
        width: 366px;
        height: 183px;
        margin-top: 40px;
    }

    .svg-wrapper {
        width: 100%;
        height: auto;
    }

    img {
        margin-top: 0;
        margin-left: 0;
    }

    .col-lg-6 {
        margin-top: 20px;
    }

    .this_flex {
        flex-direction: row;
        text-align: left;
    }


    .spcl_clss {
        margin-top: -80px;
    }

    .cust_img {
        width: 90%;
        margin: 0 auto;
    }

    /* .spcl_clss .col-lg-6:nth-child(2) img{
        width: 50%;
        height: auto;
    } */

    .account__right .account-content {
        padding-bottom: 20px;
    }

    .accordiantion_radius {
        width: 95%;
        margin: 2.5%;
    }

    .filter-sidebar {
        background: transparent;
    }

}


@media (min-width: 768px) {



    .activePage .nav-menu__link {
        position: relative;
    }

    .activePage .nav-menu__link::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 5px;
        /* Adjust height of the border */
        background: #FF7A00;
        /* Background color */
        border-radius: 5px;
        /* Rounded corners */
        top: 60px;
    }

    .btn_cousre {
        border-radius: 30px;
        padding: 15px 20px;
        border-radius: 8px;
        color: #030408;
        font-family: Poppins;
        font-size: 16px;
        /* width: 80%; */
        background: linear-gradient(93deg, #FFA34F 0.91%, #FF7A00 100%);
    }

    .cousrse_img_height {
        height: 500px;
    }
    .cust_class .cust_row{
      padding-left: 100px;
    }
    .cust_row_righgt {
        padding-right: 150px;
        padding-left: 40px;
    }


}

@media screen and (min-width: 768px) and (max-width: 1024px) {
    .section-heading__title {
        font-size: 100px;
        line-height: 100px;
    }

    .spcl_clss {
        margin-top: -285px;
    }

    .most_follwed {
        height: 270px;
    }

    .shape_top {
        display: none !important;
    }

    .header-menu {
        margin-left: 0;
    }

    .nav-menu__link {
        padding: 30px 10px;
    }

    .hero-inner__title {
        font-size: clamp(4rem, -2.0093rem + 7.85vw, 4.5rem);
        line-height: 4rem;
    }

    .learn_withcard .learm-tilte {
        width: 75%;
    }

    .course_video .imgss {
        width: 100%;
        height: auto;
    }


}

@media (max-width: 767.98px) {

    /* Adjust course description to take full width */
    .course-description {
        margin-bottom: 10px;
    }

    /* Stack the rating, author, and time vertically */
    .course-rating,
    .course-author,
    .course-time {
        display: block;
        margin-bottom: 10px;
    }

    /* Ensure the button takes full width in mobile view */
    .btn_cousre {
        width: 100%;
    }

    .spl_cards .course-title {
        font-size: 16px;
        text-align: left;
        /* 102.778% */
    }

    .spl_cards .course-description {
        font-size: 13px;

    }

    .spl_cards {
        padding: 10px;
    }

    .spl_cards .course-author {
        font-size: 13px;
    }

    .spl_cards .course-time {

        font-size: 11px;

    }

    .learn_follow {
        width: auto;
        margin-top: 25%;
    }

    .learn_withcard .img {
        width: 140px;
        height: 140px;
    }

    .teachers_card .img {
        width: 100px;
        height: 100px;
    }

    .course_video .imgss {
        width: 100px;
        height: 100px;
    }

    .course-description_1 {
        display: -webkit-box;
        /* For WebKit-based browsers */
        -webkit-box-orient: vertical;
        /* Set the orientation of the box */
        -webkit-line-clamp: 3;
        /* Limit to 3 lines */
        overflow: hidden;
        /* Hide overflow text */
        text-overflow: ellipsis;
        /* Add ellipsis (...) for overflow text */
        max-height: 4.5em;
        /* Adjust max-height to fit 3 lines (line-height * number of lines) */
    }

    .dashboard_card .chat_icons {
        width: 44px;
        height: 44px;
    }
    .circle_dot {
        position: absolute;
        width: 13px;
        height: 13px;
        right: -2px;
        bottom: 2px; 
    }
    .psotion_absoltu {
        right: 20px;
        top: 200px;
        position: absolute;
    }


}

@media screen and (min-width: 1024px) and (max-width: 1488px) {
    /* Laptop */
    .header-menu {
        margin-left: 0;
    }
    .shape_top { 
        width: 150px;
        margin-top: 70px;
        left: -40px;
    }
    .cust_class .cust_row {
        padding-left: 25px;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/responsive.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI;QACI,WAAW;QACX,qCAAqC;QACrC,WAAW;QACX,4BAA4B;IAChC;;IAEA;QACI,WAAW;QACX,oCAAoC;QACpC,WAAW;QACX,4BAA4B;QAC5B,iBAAiB;QACjB,kDAAkD;QAClD,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,cAAc;QACd,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;;AAEJ;;;AAGA;IACI;;;CAGH;;IAEG;QACI,YAAY;QACZ,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;;IAGA;QACI,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,cAAc;IAClB;;IAEA;;;OAGG;;IAEH;QACI,oBAAoB;IACxB;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,uBAAuB;IAC3B;;AAEJ;;;AAGA;;;;IAII;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,OAAO;QACP,WAAW;QACX,WAAW;QACX,gCAAgC;QAChC,mBAAmB;QACnB,qBAAqB;QACrB,kBAAkB;QAClB,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,kBAAkB;QAClB,cAAc;QACd,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,+DAA+D;IACnE;;IAEA;QACI,aAAa;IACjB;IACA;MACE,mBAAmB;IACrB;IACA;QACI,oBAAoB;QACpB,kBAAkB;IACtB;;;AAGJ;;AAEA;IACI;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mDAAmD;QACnD,iBAAiB;IACrB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;;AAGJ;;AAEA;;IAEI,iDAAiD;IACjD;QACI,mBAAmB;IACvB;;IAEA,kDAAkD;IAClD;;;QAGI,cAAc;QACd,mBAAmB;IACvB;;IAEA,sDAAsD;IACtD;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;;IAEnB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,oBAAoB;QACpB,8BAA8B;QAC9B,4BAA4B;QAC5B,mCAAmC;QACnC,qBAAqB;QACrB,qBAAqB;QACrB,gBAAgB;QAChB,uBAAuB;QACvB,uBAAuB;QACvB,yCAAyC;QACzC,iBAAiB;QACjB,qEAAqE;IACzE;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,WAAW;QACX,WAAW;IACf;IACA;QACI,WAAW;QACX,UAAU;QACV,kBAAkB;IACtB;;;AAGJ;;AAEA;IACI,WAAW;IACX;QACI,cAAc;IAClB;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,WAAW;IACf;IACA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["/* Mobile-specific styles */\r\n@media screen and (max-width: 991px) {\r\n    .account__left {\r\n        width: 100%;\r\n        /* Image takes full width on mobile */\r\n        height: 50%;\r\n        /* Takes 50% of the height */\r\n    }\r\n\r\n    .account__right {\r\n        width: 100%;\r\n        /* Form takes full width on mobile */\r\n        height: 50%;\r\n        /* Takes 50% of the height */\r\n        padding: 0px 20px;\r\n        /* Optional: adds padding for the form on mobile */\r\n        padding-top: 20px;\r\n    }\r\n\r\n    .account__right_box {\r\n        min-height: 0px;\r\n    }\r\n\r\n    .most_follwed {\r\n        height: 200px;\r\n        margin: 0 auto;\r\n        position: absolute;\r\n        top: 40px;\r\n        z-index: 0;\r\n        border-radius: 10px;\r\n    }\r\n\r\n    .section-heading__1 {\r\n        font-size: 24px;\r\n    }\r\n\r\n    .intractive {\r\n        font-size: 21px;\r\n        width: 100%;\r\n    }\r\n\r\n    .section-title {\r\n        font-size: 1.5rem;\r\n    }\r\n\r\n    .card-img {\r\n        width: 45%;\r\n        height: 140px;\r\n        border-radius: 10px;\r\n        object-fit: cover;\r\n    }\r\n\r\n    .spl_burron img {\r\n        width: 70%;\r\n    }\r\n\r\n    .feed_details_img {\r\n        width: 100%;\r\n        height: auto;\r\n        margin: 20px auto;\r\n    }\r\n\r\n    .upload_popup_medai2 .modal-body .uplad_img:first-of-type {\r\n        width: 90%;\r\n        height: 250px;\r\n    }\r\n\r\n    .upload_popup_medai2 .modal-body .uplad_img:not(:first-of-type) {\r\n        width: 90%;\r\n        height: 250px;\r\n    }\r\n\r\n    .upload_popup_medai3 .modal-body .uplad_img:first-of-type {\r\n        width: 90%;\r\n        height: 250px;\r\n    }\r\n\r\n    .upload_popup_medai3 .modal-body .uplad_img:not(:first-of-type) {\r\n        width: 90%;\r\n        height: 250px;\r\n    }\r\n\r\n}\r\n\r\n\r\n@media (max-width: 767px) {\r\n    /* .desktop-svg {\r\n        display: none;\r\n    }\r\n*/\r\n\r\n    .mobile-svg {\r\n        width: 366px;\r\n        height: 183px;\r\n        margin-top: 40px;\r\n    }\r\n\r\n    .svg-wrapper {\r\n        width: 100%;\r\n        height: auto;\r\n    }\r\n\r\n    img {\r\n        margin-top: 0;\r\n        margin-left: 0;\r\n    }\r\n\r\n    .col-lg-6 {\r\n        margin-top: 20px;\r\n    }\r\n\r\n    .this_flex {\r\n        flex-direction: row;\r\n        text-align: left;\r\n    }\r\n\r\n\r\n    .spcl_clss {\r\n        margin-top: -80px;\r\n    }\r\n\r\n    .cust_img {\r\n        width: 90%;\r\n        margin: 0 auto;\r\n    }\r\n\r\n    /* .spcl_clss .col-lg-6:nth-child(2) img{\r\n        width: 50%;\r\n        height: auto;\r\n    } */\r\n\r\n    .account__right .account-content {\r\n        padding-bottom: 20px;\r\n    }\r\n\r\n    .accordiantion_radius {\r\n        width: 95%;\r\n        margin: 2.5%;\r\n    }\r\n\r\n    .filter-sidebar {\r\n        background: transparent;\r\n    }\r\n\r\n}\r\n\r\n\r\n@media (min-width: 768px) {\r\n\r\n\r\n\r\n    .activePage .nav-menu__link {\r\n        position: relative;\r\n    }\r\n\r\n    .activePage .nav-menu__link::after {\r\n        content: '';\r\n        position: absolute;\r\n        bottom: 0;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 5px;\r\n        /* Adjust height of the border */\r\n        background: #FF7A00;\r\n        /* Background color */\r\n        border-radius: 5px;\r\n        /* Rounded corners */\r\n        top: 60px;\r\n    }\r\n\r\n    .btn_cousre {\r\n        border-radius: 30px;\r\n        padding: 15px 20px;\r\n        border-radius: 8px;\r\n        color: #030408;\r\n        font-family: Poppins;\r\n        font-size: 16px;\r\n        /* width: 80%; */\r\n        background: linear-gradient(93deg, #FFA34F 0.91%, #FF7A00 100%);\r\n    }\r\n\r\n    .cousrse_img_height {\r\n        height: 500px;\r\n    }\r\n    .cust_class .cust_row{\r\n      padding-left: 100px;\r\n    }\r\n    .cust_row_righgt {\r\n        padding-right: 150px;\r\n        padding-left: 40px;\r\n    }\r\n\r\n\r\n}\r\n\r\n@media screen and (min-width: 768px) and (max-width: 1024px) {\r\n    .section-heading__title {\r\n        font-size: 100px;\r\n        line-height: 100px;\r\n    }\r\n\r\n    .spcl_clss {\r\n        margin-top: -285px;\r\n    }\r\n\r\n    .most_follwed {\r\n        height: 270px;\r\n    }\r\n\r\n    .shape_top {\r\n        display: none !important;\r\n    }\r\n\r\n    .header-menu {\r\n        margin-left: 0;\r\n    }\r\n\r\n    .nav-menu__link {\r\n        padding: 30px 10px;\r\n    }\r\n\r\n    .hero-inner__title {\r\n        font-size: clamp(4rem, -2.0093rem + 7.85vw, 4.5rem);\r\n        line-height: 4rem;\r\n    }\r\n\r\n    .learn_withcard .learm-tilte {\r\n        width: 75%;\r\n    }\r\n\r\n    .course_video .imgss {\r\n        width: 100%;\r\n        height: auto;\r\n    }\r\n\r\n\r\n}\r\n\r\n@media (max-width: 767.98px) {\r\n\r\n    /* Adjust course description to take full width */\r\n    .course-description {\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    /* Stack the rating, author, and time vertically */\r\n    .course-rating,\r\n    .course-author,\r\n    .course-time {\r\n        display: block;\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    /* Ensure the button takes full width in mobile view */\r\n    .btn_cousre {\r\n        width: 100%;\r\n    }\r\n\r\n    .spl_cards .course-title {\r\n        font-size: 16px;\r\n        text-align: left;\r\n        /* 102.778% */\r\n    }\r\n\r\n    .spl_cards .course-description {\r\n        font-size: 13px;\r\n\r\n    }\r\n\r\n    .spl_cards {\r\n        padding: 10px;\r\n    }\r\n\r\n    .spl_cards .course-author {\r\n        font-size: 13px;\r\n    }\r\n\r\n    .spl_cards .course-time {\r\n\r\n        font-size: 11px;\r\n\r\n    }\r\n\r\n    .learn_follow {\r\n        width: auto;\r\n        margin-top: 25%;\r\n    }\r\n\r\n    .learn_withcard .img {\r\n        width: 140px;\r\n        height: 140px;\r\n    }\r\n\r\n    .teachers_card .img {\r\n        width: 100px;\r\n        height: 100px;\r\n    }\r\n\r\n    .course_video .imgss {\r\n        width: 100px;\r\n        height: 100px;\r\n    }\r\n\r\n    .course-description_1 {\r\n        display: -webkit-box;\r\n        /* For WebKit-based browsers */\r\n        -webkit-box-orient: vertical;\r\n        /* Set the orientation of the box */\r\n        -webkit-line-clamp: 3;\r\n        /* Limit to 3 lines */\r\n        overflow: hidden;\r\n        /* Hide overflow text */\r\n        text-overflow: ellipsis;\r\n        /* Add ellipsis (...) for overflow text */\r\n        max-height: 4.5em;\r\n        /* Adjust max-height to fit 3 lines (line-height * number of lines) */\r\n    }\r\n\r\n    .dashboard_card .chat_icons {\r\n        width: 44px;\r\n        height: 44px;\r\n    }\r\n    .circle_dot {\r\n        position: absolute;\r\n        width: 13px;\r\n        height: 13px;\r\n        right: -2px;\r\n        bottom: 2px; \r\n    }\r\n    .psotion_absoltu {\r\n        right: 20px;\r\n        top: 200px;\r\n        position: absolute;\r\n    }\r\n\r\n\r\n}\r\n\r\n@media screen and (min-width: 1024px) and (max-width: 1488px) {\r\n    /* Laptop */\r\n    .header-menu {\r\n        margin-left: 0;\r\n    }\r\n    .shape_top { \r\n        width: 150px;\r\n        margin-top: 70px;\r\n        left: -40px;\r\n    }\r\n    .cust_class .cust_row {\r\n        padding-left: 25px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
